import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/js/bootstrap.min.js';

const FabricFilterItem = ({ label, children }) => (
  <div className="accordion-item">
    <h2 className="accordion-header" id={label.replace(/\s/g, '') + 'Heading'}>
      <button
        className="accordion-button collapsed fw-bold px-2"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={'#' + label.replace(/\s/g, '')}
        aria-expanded="false"
        aria-controls={label.replace(/\s/g, '')}
      >
        {label}
      </button>
    </h2>
    <div
      id={label.replace(/\s/g, '')}
      className="accordion-collapse collapse"
      aria-labelledby={label.replace(/\s/g, '') + 'Heading'}
      data-bs-parent="#accordionFlushExample"
    >
      <div className="accordion-body">{children}</div>
    </div>
  </div>
);

const FabricFilterItemMap = ({ option, name, filters, onChange }) => (
  <>
    {option.has_item && (
      <div className="form-check">
        <input
          type="checkbox"
          data-id={option.id}
          data-label={option.label}
          data-type={name}
          onChange={onChange}
          id={name + '-' + option.label}
          checked={filters.includes(String(option.id))}
        />
        <span className="form-check-input" />
        <label
          className="form-check-label filter__check-label"
          htmlFor={name + '-' + option.label}
        >
          {option.label}
        </label>
      </div>
    )}
  </>
);

const FabricFilter = ({ setFilters, filters, setCurrentPage }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 980);
  const [brands, setBrands] = useState([]);
  const [types, setTypes] = useState([]);
  const [patterns, setPatterns] = useState([]);
  const [colors, setColors] = useState([]);
  const [materials, setMaterials] = useState([]);

  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 980);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const updateUrlParameters = (filters) => {
    const url = new URL(window.location);
    const urlParams = new URLSearchParams(url.search);
    ['brands', 'types', 'patterns', 'colors', 'materials'].forEach((type) => {
      urlParams.delete(type);
      filters[type].forEach((id) => {
        const label = filters.all.find((item) => item.id === id && item.type === type).label;
        urlParams.append(type, `${label.replace(/ /g, '+').replace(/&/g, '＆')}-${id}`);
      });
    });
    history.pushState({}, '', `${url.pathname}?${urlParams.toString()}`);
  };

  const onToggleFilter = (e) => {
    const id = e.target.dataset.id;
    const label = e.target.dataset.label;
    const type = e.target.dataset.type;
    setCurrentPage(1);

    if (e.target.checked && !filters[type].includes(id)) {
      filters[type] = [...filters[type], id];
      filters['all'] = [...filters['all'], { id, label, type }];
    } else {
      filters[type] = filters[type].filter((item) => item !== id);
      filters['all'] = filters['all'].filter((item) => item.id !== id);
    }

    setFilters({ ...filters });
    updateUrlParameters(filters);
  };

  const onRemoveFilter = (e) => {
    e.preventDefault();
    const id = e.target.dataset.id;
    const type = e.target.dataset.type;
    setCurrentPage(1);

    if (type === 'all') {
      document.querySelectorAll('input[type="checkbox"]:checked').forEach((checkbox) => {
        checkbox.checked = false;
      });
      setFilters({
        brands: [],
        types: [],
        patterns: [],
        colors: [],
        materials: [],
        all: [],
      });
    } else {
      const checkbox = document.querySelector(`input[data-id="${id}"]`);
      if (checkbox) {
        checkbox.checked = false;
      }
      filters[type] = filters[type].filter((item) => item !== id);
      filters['all'] = filters['all'].filter((item) => item.id !== id);
      setFilters({ ...filters });
    }
    updateUrlParameters(filters);
  };

  useEffect(() => {
    const fetchFilters = async () => {
      const queryParams = new URLSearchParams();
      Object.keys(filters).forEach((key) => {
        filters[key].forEach((filter) => {
          queryParams.append(key, filter);
        });
      });

      try {
        const [brandsRes, typesRes, patternsRes, colorsRes, materialsRes] = await Promise.all([
          client.get('/get_material_brand', { params: queryParams }),
          client.get('/get_material_type', { params: queryParams }),
          client.get('/get_material_patterns', { params: queryParams }),
          client.get('/get_material_colors', { params: queryParams }),
          client.get('/get_material_category', { params: queryParams }),
        ]);
        setBrands(brandsRes.data.result);
        setTypes(typesRes.data.result);
        setPatterns(patternsRes.data.result);
        setColors(colorsRes.data.result);
        setMaterials(materialsRes.data.result);
      } catch (error) {
        console.error('Error fetching filters:', error);
      }
    };
    fetchFilters();
  }, [filters]);

  useEffect(() => {
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const newFilters = { brands: [], types: [], patterns: [], colors: [], materials: [], all: [] };

    for (let [key, value] of urlParams.entries()) {
      if (['brands', 'types', 'patterns', 'colors', 'materials'].includes(key)) {
        const [label, id] = value.split('-');
        newFilters[key].push(id);
        newFilters.all.push({ id, label, type: key });
      }
    }

    setFilters(newFilters);
  }, [setFilters]);

  return (
    <div className={`${isMobile ? 'offcanvas offcanvas-start' : ''} filter`} tabIndex="-1" id="filterOffCanvas" aria-labelledby="filterOffCanvasLabel">
      {isMobile && (
        <div className="d-flex justify-content-end">
          <button type="button" className="btn-close text-reset p-3" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
      )}
      <div className={`${isMobile ? 'offcanvas-body overHeight' : ''}`}>
        <div className="mb-3">
          <div className="mb-3 d-flex justify-content-between filter__refine">
            <p className="m-0 fw-bold">REFINE BY</p>
            <a href="#" className="text-decoration-underline" data-type="all" onClick={onRemoveFilter}>
              clear all
            </a>
          </div>
          <div className="filter__items">
            {filters.all.map((item) => (
              <a
                href="#"
                className="badge rounded-pill text-dark fw-normal me-2"
                data-id={item.id}
                data-type={item.type}
                data-label={item.label}
                onClick={onRemoveFilter}
                key={item.id}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
        <div className="border-top border-bottom accordion accordion-flush" id="accordionFlushExample">
          <FabricFilterItem label="Fabric Brand">
            {brands.map((option) => (
              <FabricFilterItemMap option={option} name="brands" key={option.id} filters={filters.brands} onChange={onToggleFilter} />
            ))}
          </FabricFilterItem>
          <FabricFilterItem label="Fabric Type">
            {types.map((option) => (
              <FabricFilterItemMap option={option} name="types" key={option.id} filters={filters.types} onChange={onToggleFilter} />
            ))}
          </FabricFilterItem>
          <FabricFilterItem label="Pattern">
            {patterns.map((option) => (
              <FabricFilterItemMap option={option} name="patterns" key={option.id} filters={filters.patterns} onChange={onToggleFilter} />
            ))}
          </FabricFilterItem>
          <FabricFilterItem label="Color">
            {colors.map((option) => (
              <FabricFilterItemMap option={option} name="colors" key={option.id} filters={filters.colors} onChange={onToggleFilter} />
            ))}
          </FabricFilterItem>
          <FabricFilterItem label="Material">
            {materials.map((option) => (
              <FabricFilterItemMap option={option} name="materials" key={option.id} filters={filters.materials} onChange={onToggleFilter} />
            ))}
          </FabricFilterItem>
        </div>
      </div>
    </div>
  );
};

export default FabricFilter;
